
import { DashboardImageAlign, DashboardImageData } from "@/utils/dashboard/dashboard-image-data";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			imageUrl: ""
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		editMode: Boolean
	},
	computed: {
		data():DashboardImageData | null{
			if (!this.item.Data) return null;
			return this.item.Data as DashboardImageData;
		},
		parentStyle():any {
			let result:any = {};
			if (!this.data) return result;
			if (this.data.HorizontalAlign == DashboardImageAlign.Start) {
				result.alignItems = "start";
			}else if (this.data.HorizontalAlign == DashboardImageAlign.Middle) {
				result.alignItems = "center";
			}else if (this.data.HorizontalAlign == DashboardImageAlign.End) {
				result.alignItems = "end";
			}

			if (this.data.VerticalAlign == DashboardImageAlign.Start)  {
				result.justifyContent = "start";
			}else if (this.data.VerticalAlign == DashboardImageAlign.Middle){
				result.justifyContent = "center";
			}else if (this.data.HorizontalAlign == DashboardImageAlign.End) {
				result.justifyContent = "end";
			}

			result.paddingLeft = this.getPaddingNumber(this.data.PaddingLeft);
			result.paddingTop = this.getPaddingNumber(this.data.PaddingTop);
			result.paddingRight = this.getPaddingNumber(this.data.PaddingRight);
			result.paddingBottom = this.getPaddingNumber(this.data.PaddingBottom);

			result.backgroundColor = this.data.BackgroundColor;

			return result;
		},
		rootTag():string {
			if (!this.data) return "w-card";
			if (this.data.HideCardBorder) return "div";
			return "w-card";
		}
	},
	watch: {
		"data.AWSImageToken": {
			immediate: true,
			async handler(){
				await this.fetchImageLink();
			}
		},
	},
	methods: {
		async fetchImageLink(){
			if (!this.data) {
				this.imageUrl = "";
				return;
			}
			this.imageUrl = await this.data.getImageLink();
		},
		getPaddingNumber(item:number):string{
			if (typeof(item) != "number") {
				return "0px";
			}
			if (Number.isNaN(item)) {
				return "0px";
			}
			return `${item}px`;
		}
	}
});
